import moment from "moment";
import axios from "axios";

export const appMixin = {
    computed: {
        settings() {
            return this.$store.getters.getSystemSettings;
        },
        userCurrency() {
            return this.settings?.currency?.symbol || '£';
        },
        // Get working time options
        workingTimeOptions() {
            const startTime = this.momentObj(this.settings.hm_working_hours_start, 'HH:mm').format('HH'); // 07:00
            const endTime = this.momentObj(this.settings.hm_working_hours_end, 'HH:mm').subtract(1, 'hour').format('HH'); // 17:00

            const options = [];
            for (let hour = startTime; hour <= endTime; hour++) {
                // Format the hour to have leading zero and add ':00' for minutes
                const time = `${hour.toString().padStart(2, '0')}:00:00`;
                options.push({
                    id: time,
                    name: this.momentObj(time, 'HH:mm:ss').format('hh:mm A')
                });
            }
            return options;
        }
    },
    methods: {
        /**
         * Define global functions and properties here
         *
         */
        moment(date, format = null) {
            if (format) {
                return moment(date, format).utc();
            }
            return moment(date).utc();
        },
        momentObj(date, format = null) {
            if (format) {
                return moment(date, format);
            }
            return moment(date);
        },
        dataTimeFormat(date, format) {
            return moment(date).utc().format(format);
        },
        // Prepare moment without UTC
        momentWithoutUTC(date) {
            return moment(date);
        },
        // Prepare data time format without UTC
        dataTimeFormatWithoutUTC(date, format) {
            return moment(date).format(format);
        },
        truncateString(str, maxLength) {
            if (str.length > maxLength) {
                return str.substring(0, maxLength) + '...';
            }
            return str;
        },
        // Make first letter of each word capital
        capitalize(str) {
            return str.replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        },
        async getUserProfile() {
            const response = await axios.post('/api/user');
            return response.data;
        },
        async getSettings() {
            try {
                const response = await axios.post('/api/settings');
                return response.data;
            } catch (error) {
                console.error('Error fetching settings:', error);
            }
        },
        // Get handymans list for task assignment
        async getHandymanForTaskAssignment(params) {
            try {
                const response = await axios.post('/api/admin/handymans/available', params);
                return response.data;
            } catch (error) {
                console.error('Error fetching handymans:', error);
            }
        },
        padZero(num) {
            return num.toString().padStart(2, '0');
        },
        formatName(fullName) {
            if (!fullName || typeof fullName !== 'string') return '';

            const names = fullName.trim().split(/\s+/);
            if (names.length === 0) return '';

            const firstName = names[0];
            const lastNameInitial = names.length > 1 ? names[names.length - 1].charAt(0) + '.' : '';

            return `${firstName} ${lastNameInitial}`.trim();
        },
        isProvisionalOrder(order) {
            return order.order_type === 'temporary' && order.is_approved === 0;
        },
        async copyToClipboard(textToCopy) {
            try {
                await navigator.clipboard.writeText(textToCopy);
                this.$notification('success', 'Copied to clipboard');
            } catch (error) {
                this.$notification('error', 'Failed to copy to clipboard');
            }
        },
        prepareCalendarDate(date) {
            // Set the locale to ensure the week starts on Monday
            moment.locale('en', {
                week: {
                    dow: 1, // Monday is the first day of the week.
                },
            });

            // Generate dates for the selected month
            let selectedMonth = this.momentObj(date);
            let startOfMonth = selectedMonth.clone().startOf('month').startOf('week');
            let endOfMonth = selectedMonth.clone().endOf('month').endOf('week');

            let weeks = [];
            let currentWeek = [];
            let currentDay = startOfMonth.clone();

            while (currentDay.isSameOrBefore(endOfMonth)) {
                if (currentWeek.length === 7) { // Complete a week
                    weeks.push(currentWeek);
                    currentWeek = []; // Start a new week
                }

                if (currentDay.month() === selectedMonth.month()) {
                    currentWeek.push({
                        year: currentDay.format("YY"),
                        date: currentDay.format("DD"),
                        day: currentDay.format("ddd")
                    });
                } else {
                    currentWeek.push(null); // Push null for days outside the month to keep the structure
                }

                currentDay.add(1, 'days');
            }
            if (currentWeek.length > 0) { // Push the last week if it has any days
                weeks.push(currentWeek);
            }

            return weeks;
        },
        initializeTooltips() {
            const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
            tooltipTriggerList.map(function (tooltipTriggerEl) {
                // Dispose existing tooltip if it exists to avoid duplicates
                var existingTooltip = bootstrap.Tooltip.getInstance(tooltipTriggerEl);
                if (existingTooltip) {
                    existingTooltip.dispose();
                }
                return new bootstrap.Tooltip(tooltipTriggerEl);
            });
        }
    }
}
